/* eslint-disable max-lines */
/* eslint-disable camelcase */
/* eslint-disable max-depth */
/* eslint-disable operator-linebreak */
/* eslint-disable max-statements */
/* eslint-disable no-magic-numbers */

import request from '@/utils/http';
// 首页表格数据
export const getTransferConfirmList = (params) => {
    return request({
        url: `/api-tms/receipt/transferconfirm/list`,
        method: 'post',
        data: params
    });
};
// 上传
export const uploadTransfer = (params) => {
    return request({
        url: `/api-tms/receipt/upload/transfer`,
        method: 'post',
        data: params
    });
};
// 接收
export const receiptTransfertoconfirm = (params) => {
    return request({
        url: `/api-tms/receipt/transfertoconfirm`,
        method: 'post',
        data: params
    });
};
// 打印
export const receiptPrinttransfer = (params) => {
    return request({
        url: `/api-tms/receipt/printtransfer/${params}`,
        method: 'get'
    });
};
// 删除
export const deleteTransferpicture = (params) => {
    return request({
        url: `/api-tms/receipt/delete/transferpicture`,
        method: 'delete',
        data: params
    });
};
// 接收弹框 数据
export const transfersToconfirmList = (params) => {
    return request({
        url: `/api-tms/receipt/transfers/toconfirm/list/${params}`,
        method: 'get'
    });
};
